export const version = '1.9.2';
//# sourceMappingURL=version.js.map